import React, { useEffect, useRef } from "react";
import { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function QuillEditor({
  value = "",
  onChange,
  placeholder = "",
}) {
  const editorRef = useRef(null);
  const quillRef = useRef(null);

  // Initialize once
  useEffect(() => {
    if (!editorRef.current || quillRef.current) return;

    quillRef.current = new Quill(editorRef.current, {
      theme: "snow",
      placeholder,
      modules: {
        toolbar: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline"],
          ["image", "code-block"],
        ],
      },
    });

    quillRef.current.on("text-change", () => {
      const html = quillRef.current.root.innerHTML;
      onChange && onChange(html);
    });
  }, []);

  // Sync value (IMPORTANT)
  useEffect(() => {
    if (!quillRef.current) return;

    const current = quillRef.current.root.innerHTML;

    if (value !== current) {
      quillRef.current.clipboard.dangerouslyPasteHTML(value || "");
    }
  }, [value]);

  return <div ref={editorRef} className="form-control min-h-200px" />;
}